

export const changeQty = (state, index, qty) => {
  state.accessoriesListInfo[index].quantity = qty;
  if(state.accessoriesListInfo[index].selected){
    const found_index = state.accessories.findIndex((accessory) => accessory.product_id === state.accessoriesListInfo[index].id)
    state.accessories[found_index].quantity = qty
  }
}

export const changeVariant = (state, index, variant) => {
  state.accessoriesListInfo[index].selected_variant = _.cloneDeep(variant);
  if(state.accessoriesListInfo[index].selected){
    const found_index = state.accessories.findIndex((accessory) => accessory.product_id === state.accessoriesListInfo[index].id)
    state.accessories[found_index].variant_id = variant.id;
  }
}